var alignment_rtlignore_default = {
  "alignLeft": "uPXol",
  "textWrapNowrap": "NZ7nn",
  "alignRight": "-eOhT",
  "alignCenter": "fZCOY",
  "sizeFullWidth": "_99FSh",
  "renderedInTable": "ZIHov",
  "sizeOriginal": "_8t6WV",
  "sizeContent": "BUtga",
  "sizeSmall": "Rz-v3",
  "sizeSmallCenter": "eAI-r",
  "flex": "_--zJD",
  "LEFT": "jbhh5",
  "CENTER": "-MRUw",
  "RIGHT": "o-LK-",
  "AUTO": "_4OSHH",
  "JUSTIFY": "UVLRz"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
